import { useSyncExternalStore, type ReactElement } from "react";
import { Button, ServerNotice, logical } from "../../ui/kit/index.ts";
import { type MaintenanceWarnings } from "./maintenance-warning.ts";
import { slotRect } from "./area-slots.ts";
import type { HudArea } from "./slots.ts";
import { say } from "../../words.ts";

/**
 * The maintenance strip in the HUD (ADR-078 decision 6): the server notice in its "soon" tone at top centre, with Log
 * out now in the last minute, shown from 5 minutes before the start. The warning's toast is drawn by the toast column
 * (`toast-column.tsx`), which it shares with the level-up toast.
 */

/**
 * The strip in its slot.
 *
 * @param props The `area` it is laid out on, the page's `warnings`, and `onLogOut`, the game menu's Log out, which
 *   Log out now runs.
 * @returns The slot, empty while the strip is not due.
 */
export function MaintenanceSlots({ area, warnings, onLogOut }: { readonly area: HudArea; readonly warnings: MaintenanceWarnings; readonly onLogOut: (() => void) | undefined }): ReactElement {
  const { strip } = useSyncExternalStore(warnings.subscribe, warnings.getSnapshot, warnings.getSnapshot);
  const top = slotRect("maintenance", area);
  return (
    <>
      {strip === null ? null : (
        <div className="ot-hud-slot" data-hud-slot="maintenance" style={{ left: logical(top.left), top: logical(top.top), width: logical(top.width), height: logical(top.height) }}>
          <ServerNotice
            tone="soon"
            title={strip.title}
            text={strip.text}
            width={top.width}
            action={
              strip.logOut ? (
                <Button {...(onLogOut === undefined ? {} : { onClick: onLogOut })}>{say("hud.maintenance.logOut")}</Button>
              ) : undefined
            }
          />
        </div>
      )}
    </>
  );
}
